import { Box, Breadcrumbs, Button, Container, Divider, Link, Stack, TextField, Typography, colors } from '@mui/material';
import React from 'react';
import SuccessIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';

const RegistrationSuccessPage = () => {
  const [state, setState] = React.useState({});
  const navigate = useNavigate();
  return (
    <Stack sx={{ minHeight: '100vh', backgroundColor: colors.cyan[50] }}>
      <Container maxWidth='md' sx={{ minHeight: '100vh', backgroundColor: colors.common.white, padding: 2 }}>
        <Button onClick={() => navigate('/')}>SDGs Repository</Button>
        <Stack alignItems='center' p={2} spacing={2}>
          <SuccessIcon sx={{ fontSize: 64, color: colors.blue[400] }} />
          <Typography variant='h4'>Registration Success</Typography>
        </Stack>
        <Divider />
        <Stack direction='column' p={2} alignItems='center'>
          <Stack direction='row' justifyContent='flex-end' alignItems='center' spacing={1}>
            <Typography variant='body2'>Waiting for verification.</Typography>
            {/* <Typography onClick={() => navigate('/register/check')} variant='body2' sx={{ cursor: 'pointer' }}>
              Check registration status?
            </Typography> */}
            <Typography onClick={() => navigate('/')} variant='body2' sx={{ cursor: 'pointer' }}>
              Back to document repository
            </Typography>
          </Stack>
        </Stack>
      </Container>
    </Stack>
  );
};

export default RegistrationSuccessPage;
